import {combineReducers} from 'redux';

import * as actionTypes from './actionTypes';

const initialState = {
    error: null,
    loading: false,
    groupPosts: {},
};

const groupPosts = (state = initialState.groupPosts, action) => {
    switch (action.type){
        case actionTypes.ADD_POST:
            return {
                ...state,
                [action.post.groupId]: [action.post, ...state[action.post.groupId]],
            };
        case actionTypes.REMOVE_POST:
            return {
                ...state,
                [action.post.groupId]: state[action.post.groupId].filter(
                    post => post.id !== action.post.id
                ),
            };
        case actionTypes.MODIFY_POST:
            return {
                ...state,
                [action.post.groupId]: state[action.post.groupId].map(post =>
                    post.id === action.post.id ? action.post : post
                ),
            };
        case actionTypes.ADD_GROUP:
            return {
                ...state,
                [action.group.groupId]: action.group.posts,
            };
        default:
            return state;
    }
}

const error = (state = initialState.error, action) => {
    switch (action.type) {

        case actionTypes.ERROR:
            return action.error;
        default:
            return state;
    }
}

const loading = (state = initialState.loading, action) => {
    switch (action.type) {
        case actionTypes.LOADING:
            return true;
        case actionTypes.LOADED:
            return false;
        case actionTypes.ERROR:
            return false;
        default:
            return state;
    }
}

const reducer = combineReducers({
    error,
    loading,
    groupPosts
});

export default reducer;
